import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Tabs from "devextreme-react/tabs";
import { useHistory, useRouteMatch } from "react-router-dom";
import GenericDataGrid from "../components/generic/GenericDataGrid";
import { useMemo } from "react";

export const tabs = [
  {
    id: 0,
    text: "Vendors",
    icon: "user",
    content: (
      <GenericDataGrid
        resourceName="vendor"
        reduxName="vendors"
        columns={[
          { dataField: "name", caption: "Name" },
          { dataField: "address", caption: "Address" },
          { dataField: "bank_details", caption: "Bank" },
          { dataField: "rank", caption: "Rank", width: 50 },
          { dataField: "payment_time", caption: "Payment Time", width: 50 },
        ]}
      />
    ),
  },
  {
    id: 1,
    text: "Clients",
    icon: "group",
    content: (
      <GenericDataGrid
        resourceName="client"
        reduxName="clients"
        columns={[
          { dataField: "name", caption: "Name" },
          { dataField: "address", caption: "Address" },
        ]}
      />
    ),
  },
  {
    id: 2,
    text: "Currencies",
    icon: "money",
    content: (
      <GenericDataGrid
        reduxName="currencies"
        resourceName="currency"
        columns={[{ dataField: "name", caption: "Name" }]}
      />
    ),
  },
  {
    id: 3,
    text: "State/Status",
    icon: "globe",
    content: (
      <div>
        <GenericDataGrid
          reduxName="states"
          resourceName="state"
          columns={[{ dataField: "state", caption: "State" }]}
        />
        <GenericDataGrid
          reduxName="statuses"
          resourceName="status"
          columns={[{ dataField: "status", caption: "Status" }]}
        />
      </div>
    ),
  },
  {
    id: 4,
    text: "Remarks",
    icon: "clock",
    content: (
      <GenericDataGrid
        reduxName="remarks"
        resourceName="remark"
        columns={[
          { dataField: "stage", caption: "Stage" },
          { dataField: "remarks", caption: "Remarks" },
          { dataField: "terms", caption: "Terms" },
          { dataField: "part1", caption: "Part 1", width: 80 },
          { dataField: "part2", caption: "Part 2", width: 80 },
          { dataField: "part3", caption: "Part 3", width: 80 },
        ]}
      />
    ),
  },
  {
    id: 5,
    text: "Delivery Terms",
    icon: "file",
    content: (
      <GenericDataGrid
        reduxName="deliveryTerms"
        resourceName="delivery-terms"
        columns={[{ dataField: "name", caption: "Name" }]}
      />
    ),
  },
  {
    id: 6,
    text: "Sales Persons",
    icon: "group",
    content: (
      <GenericDataGrid
        reduxName="employees"
        resourceName="employee"
        columns={[
          { dataField: "name", caption: "Name" },
          { dataField: "surname", caption: "Surname" },
          { dataField: "user_name", caption: "User Name" },
          { dataField: "discount", caption: "Discount", width: 80 },
          { dataField: "reports", caption: "Reports", width: 80 },
          { dataField: "vendors_level", caption: "Vendors Level", width: 80 },
        ]}
      />
    ),
  },
  {
    id: 7,
    text: "Addresses/Banks",
    icon: "home",
    content: (
      <div>
        <GenericDataGrid
          reduxName="banks"
          resourceName="bank"
          columns={[
            { dataField: "name", caption: "Name" },
            { dataField: "desc", caption: "Description1" },
            { dataField: "desc1", caption: "Description2" },
          ]}
        />
        <GenericDataGrid
          reduxName="addresses"
          resourceName="address"
          columns={[
            { dataField: "name", caption: "Name" },
            { dataField: "desc", caption: "Description" },
          ]}
        />
      </div>
    ),
  },
];

const DataPage = () => {
  const { url } = useRouteMatch();
  const step = window.location.pathname.split("/").pop();

  const [selectedIndex, setSelectedIndex] = useState(
    !isNaN(step) && step > 0 ? step : 0
  );
  const history = useHistory();
  const onTabsSelectionChanged = (args) => {
    if (args.name === "selectedIndex") {
      setSelectedIndex(args.value);
      history.push(`${url}/${args.value}`);
    }
  };

  const finalSelectedIndex = useMemo(() => {
    return !isNaN(step) && step && step !== -1 && step > 0 ? step : 0;
  }, [step]);

  return (
    <div>
      <Typography paragraph>Data</Typography>
      <Tabs
        dataSource={tabs}
        selectedIndex={parseInt(finalSelectedIndex)}
        onOptionChanged={onTabsSelectionChanged}
      />
      {tabs[selectedIndex].content}
    </div>
  );
};

export default DataPage;
